import { render, staticRenderFns } from "./LegoTooltip.vue?vue&type=template&id=1256a39d&scoped=true"
import script from "./LegoTooltip.vue?vue&type=script&lang=js"
export * from "./LegoTooltip.vue?vue&type=script&lang=js"
import style0 from "./LegoTooltip.vue?vue&type=style&index=0&id=1256a39d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1256a39d",
  null
  
)

export default component.exports